import { useState } from 'react'
import Box from '@mui/joy/Box'
import Snackbar from '@mui/joy/Snackbar'
import { useMutation } from '@tanstack/react-query'
import { Wizard } from '../components/Wizard'
import { StepProgress } from '../components/ui/Stepper'
import { UserProfileForm } from '../components/UserProfileForm'
import { NetworkConnectionForm } from '../components/NetworkConnectionForm'
import { useSearchParams } from 'react-router-dom'
import { OnboardingComplete } from '../components/OnboardingComplete'
import { OrgAPI } from '../api/OrgAPI'
import { NetworkAPI } from '../api/NetworkAPI'
import logo from '../logo-dark.png'
import { Copyright } from '../components/Copyright'

export const Onboarding = () => {
    const [searchParams] = useSearchParams()
    const isResume = searchParams.get('state') === 'resume'

    const [snackColor, setSnackColor] = useState('danger')
    const [isSnackOpen, setIsSnackOpen] = useState(false)
    const [snackMsg, setSnackMsg] = useState(null)

    const [step, setStep] = useState(0)
    const stepLabels = [
        'Company Info',
        'Connect Social Networks',
        'Get Started',
    ]

    const showMsg = (message, color) => {
        setSnackColor(color)
        setSnackMsg(message)
        setIsSnackOpen(true)
    }

    const { mutate: connectAccount } = useMutation({
        mutationKey: ['connect-account'],
        mutationFn: NetworkAPI.connectAccount,
        onSuccess: ({ data }) => {
            window.location.href = data.authorization_url
        },
        onError: () => {
            const message =
                'Something went wrong while connecting your account. Please try again.'
            showMsg(message, 'danger')
        },
    })

    let steps = [
        {
            component: <UserProfileForm />,
            stepFunc: {
                name: 'onSubmit',
                execute: ({ name, description }) =>
                    OrgAPI.updateOrgProfile({ name, description }),
            },
        },
        {
            component: (
                <NetworkConnectionForm connectAccount={connectAccount} />
            ),
            stepFunc: {
                name: 'onNext',
            },
        },
        {
            component: <OnboardingComplete />,
            stepFunc: {
                name: 'onNext',
            },
        },
    ]

    if (isResume) {
        steps.shift()
    }

    const handleStepChange = (currentStep) => {
        if (currentStep < steps.length) {
            setStep(currentStep)
        } else {
            window.location.href = '/merchant/calendar_v2'
        }
    }

    return (
        <Box
            sx={{
                height: '100%',
                display: 'flex',
                flex: 1,
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                gap: 5,
            }}
        >
            <Box sx={{ width: '100%', m: 5 }}>
                <StepProgress
                    activeStep={isResume ? step + 1 : step}
                    steps={stepLabels}
                />
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    flex: 1,
                    flexDirection: 'column',
                    gap: 2,
                }}
            >
                <Wizard steps={steps} onStepChange={handleStepChange} />
                <Snackbar
                    variant="solid"
                    color={snackColor}
                    autoHideDuration={3000}
                    onClose={() => setIsSnackOpen(false)}
                    open={isSnackOpen}
                >
                    {snackMsg}
                </Snackbar>
                <Box
                    sx={{
                        my: 4,
                        display: 'flex',
                        flex: 1,
                        flexDirection: 'column',
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                        gap: 2,
                    }}
                >
                    <img height="30" src={logo} />
                    <Copyright />
                </Box>
            </Box>
        </Box>
    )
}
